import { useEffect } from 'react';

/**
 * Warns the user when they try to leave the page (refresh/close/route)
 * while there are unsaved changes.
 *
 * Only intended for major forms (profile, broadcast, product, admin memo).
 * Do not use on toggle-only or auto-save UIs.
 */
export const useUnsavedGuard = (isDirty, message = '저장하지 않은 변경사항이 있습니다. 페이지를 나가시겠습니까?') => {
  useEffect(() => {
    if (!isDirty) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty, message]);
};

export default useUnsavedGuard;
